import { useState } from 'react'
import FormLoader from '../../../../components/loader/FormLoader'
import Modal from '../../../../components/modal/Modal'
import { put } from '../../../../utils/Api'
import { useGlobalContext } from '../../../../utils/Context'

function ChangePassword() {
  const { notify, fetchUserProfile } = useGlobalContext()
  const [cancelLoading, setCancelLoading] = useState(false)
  const [oldPassword, setOldPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')

  async function changeRole() {
    if (!oldPassword || !newPassword || !confirmPassword) {
      notify('warn', 'All password fields are required')
      return
    }

    if (newPassword !== confirmPassword) {
      notify('warn', 'New password and confirm password do not match')
      return
    }

    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?_&#])[A-Za-z\d@$!%*?&#]{6,}$/
    if (!passwordRegex.test(newPassword)) {
      notify(
        'warn',
        'Password must contain at least 6 characters, including uppercase, lowercase, number, and special character'
      )
      return
    }

    const data = {
      oldPassword: oldPassword,
      newPassword: newPassword,
    }

    setCancelLoading(true)
    put(`business_admin/change-password`, data)
      .then((result: any) => {
        if (result.status === 200) {
          notify('success', 'Password Changed Successfully')
          fetchUserProfile()
        } else {
          notify('error', result.message)
        }
        setCancelLoading(false)
      })
      .catch(() => {
        setCancelLoading(false)
      })
  }
  return (
    <Modal position='center'>
      <div className='payment-modal'>
        <h1>Change Password</h1>
        <p>This is a mandatory first password change for security purposes.</p>
        <input
          type='password'
          placeholder='Old Password'
          value={oldPassword}
          onChange={(e) => setOldPassword(e.target.value)}
        />
        <input
          type='password'
          placeholder='New Password'
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
        />
        <input
          type='password'
          placeholder='Confirm Password'
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />
        {cancelLoading ? (
          <FormLoader position='center' />
        ) : (
          <div className='buttons flex justify-center'>
            <button className='proceed' onClick={changeRole}>
              Change Password
            </button>
          </div>
        )}
      </div>
    </Modal>
  )
}

export default ChangePassword
